import { createReducer, on } from "@ngrx/store";
import { initialWishlistState } from "./wishlist.state";
import * as WishlistActions from '../wishlist/wishlist.action';



export const wishlistReducer = createReducer (
initialWishlistState,
 on(WishlistActions.loadWishlist, state => ({
    ...state,
    loading: true,

  })),

on(WishlistActions.loadWishlistSuccess, (state, { products }) => ({
  ...state,
  products,   
  loading: false,
  ids:products.map(p=>p._id)
})),


   on(WishlistActions.addToWishlistSuccess, (state, { productId }) => ({
   
    ...state,
    ids: [...state.ids, productId]
  })),

  on(WishlistActions.removeFromWishlistSuccess, (state, { productId }) => ({
    ...state,
    products: state.products.filter(p => p._id !== productId),
    ids:state.ids.filter(id => id !== productId),
  })),

  on(WishlistActions.clearWishlistSuccess, (state) => ({   
    ...state,
    products: [],
    ids:[]
  })), 

)